import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { startCheckout, formatErr } from "@/lib/api";
import { PLANS } from "@/lib/constants";
import { CheckoutDisclosure } from "@/components/FundingDisclosure";
import { toast } from "sonner";

export function UpgradeGate({ pkg, title, children }) {
  const [busy, setBusy] = useState(null);
  const options = PLANS.filter((p) => p.pkg === pkg || p.pkg === "suite");
  const buy = async (key) => {
    setBusy(key);
    try {
      await startCheckout(key);
    } catch (e) {
      toast.error(formatErr(e));
      setBusy(null);
    }
  };
  return (
    <div className="border border-slate-200 bg-white rounded-lg p-8 md:p-12 grid-bg relative overflow-hidden" data-testid={`upgrade-gate-${pkg}`}>
      <div className="relative max-w-xl">
        <span className="h-11 w-11 rounded-md bg-slate-900 text-white grid place-items-center mb-6"><Lock className="h-5 w-5" /></span>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">{title}</h2>
        <p className="mt-3 text-slate-600 leading-relaxed">{children}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          {options.map((p) => (
            <Button key={p.key} onClick={() => buy(p.key)} disabled={!!busy} data-testid={`gate-buy-${p.key}`}
              className={p.pkg === "suite" ? "bg-slate-900 hover:bg-slate-800" : "bg-emerald-600 hover:bg-emerald-700"}>
              {busy === p.key && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
              {p.name} — ${p.price}{p.period}
            </Button>
          ))}
        </div>
        <CheckoutDisclosure className="mt-4" id={`gate-${pkg}`} />
      </div>
    </div>
  );
}
